module.exports = __webpack_public_path__ + "img/img_logo.b219e048.png";